
import { useEffect, useState } from "react";
import axios from "axios";
import image0 from '../images/Full_Cream_Milk.jpg'
import image1 from '../images/Toned_Milk.jpg'
import image2 from '../images/Tea-Milk.jpg'
import image3 from '../images/Curd.jpg'
import image4 from '../images/CupCurd.jpg'
import image5 from '../images/BucketCurd.jpg'
import image6 from '../images/Junnu.jpg'
import image7 from '../images/Gulab-Jamun.jpg'
import image8 from '../images/Basundi.jpg'
import image9 from '../images/Cones.jpg'
import image10 from '../images/Kulfis.jpg'
import image11 from '../images/Premium-Tubs.jpg'
import Lastmenu from "./LastMenu";


const Description = ({ productId }) => {
  const [description, setDescription] = useState([]);

  const productImages = {
    1: image0,
    2: image1,
    3: image2,
    4: image3,
    5: image4,
    6: image5,
    7: image6,
    8: image7,
    9: image8,
    10: image9,
    11: image10,
    12: image11,
  };
  
  const imgFrame = (productId) => productImages[productId] || "no-image.jpg";
  

  // Fetch subproduct details when `productId` updates
  useEffect(() => {
    if (productId) {
      axios
        .get(`https://dairy-api-kzjx.onrender.com/subproducts/${productId}`)
        .then((response) => {
          if (response.data.sub_products?.length > 0) {
            setDescription(response.data.sub_products);
          } else {
            alert(`No products found for product ${productId}.`);
          }
        })
        .catch((error) => {
          console.error("Error fetching products:", error);
          alert("Failed to fetch product data.");
        });
    }
  }, [productId]);

  return (
    <>
    <div className="frame1 animated-frame">
      <div style={{textAlign: 'center'}}>
      <img src={imgFrame(productId)} alt="Product Image" className="product-images" />
      </div>
        {description.length > 0 ? (
          description.map((desc, index) => (
            <div key={index}>
              
              <p>{desc?.description || `Product ${index + 1}`}</p>
              <p>{desc?.quantity || "N/A"}</p>
            </div>
          ))
        ) : (
          <p>Loading product details...</p>
        )}
      
    </div>
    <Lastmenu />
    </>
  );
};

export default Description;
